import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const bannerApi = factory.get("banner");
const initialState = {
  searchBody: {},
  banner: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      title: "",
      logo: "",
      url: "",
      is_hidden: false,
      province_ids: [],
    },
  },
  banners: {
    loading: false,
    data: [],
    total: 0,
  },
};

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.banner.dialog = !state.banner.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.banners.data = payload.data.data;
      state.banners.total = payload.data.total;
    },
    setById: (state, { payload }) => {
      state.banner.form.id = payload.id;
      state.banner.form.title = payload.title;
      state.banner.form.logo = payload.logo;
      state.banner.form.url = payload.url;
      state.banner.form.is_hidden = payload.is_hidden;
      state.banner.form.province_ids = payload.provinces ?? [];
    },
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    resetForm: (state, action) => {
      state.banner.form = initialState.banner.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
} = bannerSlice.actions;

export default bannerSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("banner"));
    const res = await bannerApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("banner"));
  } catch (err) {
    dispatch(setLoading("banner"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await bannerApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("banner"));
    const res = await bannerApi.getById(id);
    dispatch(setById(res.data.data[0]));

    dispatch(setDialog());
    dispatch(setLoading("banner"));
  } catch (err) {
    dispatch(setLoading("banner"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    await bannerApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة  بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await bannerApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Banner = {
  getAll,
  deleteById,
  getById,
  create,
  update,
};
